/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetWalletsResponseBtcItemWalletType = typeof GetWalletsResponseBtcItemWalletType[keyof typeof GetWalletsResponseBtcItemWalletType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWalletsResponseBtcItemWalletType = {
  ETH: 'ETH',
  BTC: 'BTC',
  LTC: 'LTC',
  BCH: 'BCH',
  XRP: 'XRP',
  DOT: 'DOT',
  ADA: 'ADA',
  DOGE: 'DOGE',
  TRX: 'TRX',
  ARB: 'ARB',
  BSV: 'BSV',
} as const;
